import SplashSlider from './SplashSlider';

export default SplashSlider;
